var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reveal-v2" },
    [
      _c(
        "header",
        { staticClass: "rv2-header" },
        [
          _vm._m(0),
          _c("RevealV2MenuBar", { on: { action: _vm.onMenuAction } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "rv2-stage" },
        [
          _vm.geneKg || _vm.geneKgLoading || _vm.geneKgError
            ? _c("RevealV2GeneKgPanel", {
                attrs: {
                  "gene-kg": _vm.geneKg,
                  loading: _vm.geneKgLoading,
                  error: _vm.geneKgError,
                },
              })
            : _vm.lastSearch
            ? _c("div", { staticClass: "rv2-search-summary" }, [
                _c("div", { staticClass: "rv2-search-summary-head" }, [
                  _c("span", { staticClass: "rv2-search-summary-type" }, [
                    _vm._v(_vm._s(_vm.lastSearchLabel)),
                  ]),
                  _vm.lastSearch.gene
                    ? _c("span", { staticClass: "rv2-search-summary-gene" }, [
                        _vm._v(" Gene: " + _vm._s(_vm.lastSearch.gene) + " "),
                      ])
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "rv2-search-summary-query" }, [
                  _vm._v(_vm._s(_vm.lastSearch.query)),
                ]),
                _c("p", { staticClass: "rv2-search-summary-count" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        (_vm.lastSearch.results &&
                          _vm.lastSearch.results.length) ||
                          0
                      ) +
                      " result(s) "
                  ),
                ]),
              ])
            : _c("p", { staticClass: "rv2-placeholder" }, [
                _vm._v("REVEAL workspace — start from the welcome panel."),
              ]),
        ],
        1
      ),
      _c("RevealV2WelcomePanel", {
        attrs: {
          open: _vm.welcomeOpen,
          dismissible: true,
          "focus-learn": _vm.welcomeFocusLearn,
          "initial-search-text": _vm.activeSearchText,
        },
        on: {
          close: _vm.onWelcomeClose,
          search: _vm.onWelcomeSearch,
          "import-session": _vm.onImportSession,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rv2-brand" }, [
      _c("span", { staticClass: "rv2-mark" }, [_vm._v("REVEAL")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }